export default "__VITE_ASSET__5uunPe1n__"